import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="android" task="add" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "java"
    }}>{`Java`}</h4>
    <ol>
      <li parentName="ol">{`Add the Campaign Classic extension to your project using the app's Gradle file.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`implementation 'com.adobe.marketing.mobile:campaignclassic:1.+'
`}</code></pre>
    <p>{`or you can manually include the binaries found in the `}<a parentName="p" {...{
        "href": "https://github.com/Adobe-Marketing-Cloud/acp-sdks/"
      }}>{`acp-sdks`}</a>{` repo on GitHub.`}</p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Import the Campaign Classic and Lifecycle extensions in your application's main activity.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`import com.adobe.marketing.mobile.CampaignClassic;
import com.adobe.marketing.mobile.Lifecycle;
`}</code></pre>
    <Variant platform="ios" task="add" repeat="8" mdxType="Variant" />
    <ol>
      <li parentName="ol">{`Add the Campaign Classic and `}<a parentName="li" {...{
          "href": "../mobile-core/index.md"
        }}>{`Mobile Core`}</a>{` libraries to your project.`}</li>
    </ol>
    <p>{`You can manually include the `}<a parentName="p" {...{
        "href": "https://github.com/Adobe-Marketing-Cloud/acp-sdks/releases/tag/v1.0.1-ACPCore"
      }}>{`Mobile Core`}</a>{` and `}<a parentName="p" {...{
        "href": "https://github.com/Adobe-Marketing-Cloud/acp-sdks/releases/tag/v1.0.0-ACPCampaignClassic"
      }}>{`Campaign Classic`}</a>{` libraries found in Github or add the following pods to your `}<inlineCode parentName="p">{`Podfile`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-pod"
      }}>{`pod 'ACPCampaignClassic'
pod 'ACPLifecycle'
pod 'ACPCore'
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`In the Xcode project, import the Mobile Core and Campaign Classic extensions:`}</li>
    </ol>
    <p><strong parentName="p">{`Objective-C`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`   #import "ACPCore.h"
   #import "ACPCampaignClassic.h"
   #import "ACPLifecycle.h"
`}</code></pre>
    <p><strong parentName="p">{`Swift`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`   import ACPCore
   import ACPCampaignClassic
   import ACPLifecycle
`}</code></pre>
    <Variant platform="android" task="register" repeat="2" mdxType="Variant" />
    <p>{`In your app's `}<inlineCode parentName="p">{`OnCreate`}</inlineCode>{` method, register the Campaign Classic and Lifecycle extensions:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public class CampaignClassicTestApp extends Application {

    @Override
    public void onCreate() {
        super.onCreate();
        MobileCore.setApplication(this);
        MobileCore.setLogLevel(LoggingMode.VERBOSE);

        try {
            CampaignClassic.registerExtension();
            Lifecycle.registerExtension();
            MobileCore.start(null);
        } catch (Exception e) {
            Log.e("CampaignClassicTestApp", e.getMessage());
        }

    }
}
`}</code></pre>
    <Variant platform="ios" task="register" repeat="5" mdxType="Variant" />
    <p>{`In your app's `}<inlineCode parentName="p">{`application:didFinishLaunchingWithOptions:`}</inlineCode>{` method, register the Campaign Classic and Lifecycle extensions:`}</p>
    <h4 {...{
      "id": "swift"
    }}>{`Swift`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`func application(_ application: UIApplication, didFinishLaunchingWithOptions launchOptions: [UIApplication.LaunchOptionsKey: Any]?) -> Bool {
   ACPCampaignClassic.registerExtension();
   ACPLifecycle.registerExtension();
  // Override point for customization after application launch.
  return true;
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c"
    }}>{`Objective-C`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`- (BOOL)application:(UIApplication *)application didFinishLaunchingWithOptions:(NSDictionary *)launchOptions {
    [ACPCampaignClassic registerExtension];
    [ACPLifecycle registerExtension];
  // Override point for customization after application launch.
  return YES;
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      